namespace $.$$ {
	export class $shm_hitalama_components_drafts extends $.$shm_hitalama_components_drafts {
		@ $mol_mem
		selected( next?: string ) {
			const key = 'application-draft:' + this.model().owner().link().str
			if( next !== undefined ) {
				if( next ) this.$.$mol_state_local.value( key, next )
				this.$.$mol_state_arg.value( 'application_draft', next )
				return next
			}
			const id = this.$.$mol_state_arg.value( 'application_draft' ) ?? this.$.$mol_state_local.value<string>( key ) ?? ''
			return this.model().has( id ) ? id : ''
		}
		@ $mol_mem
		editing( next?: boolean ) {
			return this.$.$mol_state_arg.value( 'application_draft_edit', next === undefined ? undefined : String( next ) ) !== 'false'
		}
		@ $mol_action
		opened( event?: Event | null ) {
			if( event ) {
				this.editing( true )
				const id = this.selected()
				new this.$.$mol_after_frame( ()=> {
					if( this.selected() === id && this.editing() && this.model().can_change() ) $mol_wire_async( this.Editor() ).focus_end( id )
				} )
			}
			return null
		}
		draft_pages() {
			if( !this.selected() || !this.model().has( this.selected() ) ) return [ this.List() ]
			return [ this.List(), this.Preview(), ...( this.editing() && this.model().can_change() ? [ this.Editor() ] : [] ) ]
		}
		@ $mol_action
		created( event?: Event | null ) {
			return this.opened( event )
		}
		@ $mol_action
		close( event?: Event | null ) {
			if( event ) { this.editing( false ); this.selected( '' ) }
			return null
		}
	}
}
